import { BENEFIT_TYPE_BASIC_LIFE } from '@hixme/benefit-types'
import { clearModal } from '@hixme/modal'
import { connect } from 'react-redux'
import { getWaiter } from 'redux-waiter'

// project
import DeclineCoverageModal from 'components/DeclineCoverageModal'
import { createErrorNotification } from 'modules/notification-manager/actions'

// store
import { datadog } from 'helpers/datadog'
import cart from 'store/modules/cart'

// project

// store
import { handleActivityLogPopup } from 'helpers/activityLogHelper'
import withFeatureFlags from 'hocs/withFeatureFlags'
import { logGenericActivity } from 'modules/activity-log/log-generic-activity'
import { ShopForHealthAction } from 'routes/Benefits/HealthBundles/shop-for-health-activity-log/shop-for-health-log'
import person from 'store/modules/persons'
import { isImpersonating } from 'store/modules/user-session/selectors'

const mapStateToProps = (state, { data, flags }) => ({
  coveredPersons: data.persons,
  benefitProducts: [data.benefit],
  isProcessing:
    getWaiter(state, cart.constants.getBenefitPath(BENEFIT_TYPE_BASIC_LIFE)).isPending || false,
  isActivityLogEnabled: flags['enrollme.activity-log-reason-popup-enabled'],
  isImpersonated: isImpersonating(state),
  isTestUser: person?.selectors?.getPersonSelector(state)?.IsTestUser,
})

const mapDispatchToProps = (dispatch) => ({
  onDeclineClick: (coveredPersons, [benefit], enrollmentKey, props) => {
    const callback = ({ reason, reasonCategory, zendeskTicket }) => {
      dispatch(cart.actions.declineBenefit(BENEFIT_TYPE_BASIC_LIFE, coveredPersons, benefit)).then(
        () => {
          logGenericActivity({
            additionalData: {
              persons: coveredPersons,
              benefit,
              enrollmentKey,
              reason,
              reasonCategory,
              zendeskTicket,
            },
            activity: 'declined basic life coverage',
            action: ShopForHealthAction.DeclineBasicLifeCoverage,
          })
          datadog.declineBenefits(BENEFIT_TYPE_BASIC_LIFE, coveredPersons, benefit)
          dispatch(clearModal())
        },
        () => {
          dispatch(clearModal())
          dispatch(
            createErrorNotification('There was an error declining basic life. Please try again.')
          )
        }
      )
    }

    handleActivityLogPopup({
      isImpersonated: props.isImpersonated,
      isTestUser: props.isTestUser,
      isActivityLogEnabled: props.isActivityLogEnabled,
      dispatch,
      contentText: 'Are you sure you want to decline this basic life coverage?',
      onSubmit: callback,
    })
  },
})

export default withFeatureFlags(connect(mapStateToProps, mapDispatchToProps)(DeclineCoverageModal))
